/**
 * Note: IMP Values can be only added & never deleted here
 * This is because the values are stored in the database as string
 */
export enum PickerIconsEnum {
  BeverageCoffee = 'BeverageCoffee',
  ChatQuestion = 'ChatQuestion',
  Crown = 'Crown',
  Hexagon = 'Hexagon',
  MoneyBillsCoins = 'MoneyBillsCoins',
  PersonCircle = 'PersonCircle',
  Square = 'Square',
  BeverageWineGlasses = 'BeverageWineGlasses',
  Circle = 'Circle',
  Cutlery = 'Cutlery',
  Holiday = 'Holiday',
  MoneyBillsStack = 'MoneyBillsStack',
  Plane = 'Plane',
  Star = 'Star',
  Book = 'Book',
  CirclePlay = 'CirclePlay',
  Diamond = 'Diamond',
  Home = 'Home',
  Office = 'Office',
  Plus = 'Plus',
  Target = 'Target',
  BookOpenPencil = 'BookOpenPencil',
  Club = 'Club',
  Document = 'Document',
  Image = 'Image',
  OrgChart = 'OrgChart',
  QuestionCircle = 'QuestionCircle',
  Triangle = 'Triangle',
  Bookmark = 'Bookmark',
  Code = 'Code',
  GraphArea = 'GraphArea',
  Info = 'Info',
  ParagraphGrid = 'ParagraphGrid',
  Resume = 'Resume',
  BulletList = 'BulletList',
  Computer = 'Computer',
  GraphBar = 'GraphBar',
  Job = 'Job',
  PartyPopper = 'PartyPopper',
  Schedule = 'Schedule',
  Car = 'Car',
  ContactCard = 'ContactCard',
  GraphLine = 'GraphLine',
  Link = 'Link',
  Path = 'Path',
  SmileyFace = 'SmileyFace',
  Chat = 'Chat',
  CreditCard = 'CreditCard',
  Heart = 'Heart',
  LocationPin = 'LocationPin',
  People = 'People',
  Spade = 'Spade',
}
export type GroupListType = {
  name: string;
  icons: PickerIconsEnum[];
}[];

export const DEFAULT_GROUP_LIST: GroupListType = [
  {
    name: 'Shape',
    icons: [
      PickerIconsEnum.Circle,
      PickerIconsEnum.Square,
      PickerIconsEnum.Triangle,
      PickerIconsEnum.Star,
      PickerIconsEnum.Bookmark,
      PickerIconsEnum.Heart,
      PickerIconsEnum.Hexagon,
      PickerIconsEnum.Diamond,
      PickerIconsEnum.Club,
      PickerIconsEnum.Spade,
      PickerIconsEnum.Plus,
      PickerIconsEnum.Crown,
      PickerIconsEnum.CirclePlay,
    ],
  },
  {
    name: 'Business',
    icons: [
      PickerIconsEnum.Office,
      PickerIconsEnum.Home,
      PickerIconsEnum.Job,
      PickerIconsEnum.Document,
      PickerIconsEnum.Computer,
      PickerIconsEnum.OrgChart,
      PickerIconsEnum.LocationPin,
      PickerIconsEnum.Car,
      PickerIconsEnum.Plane,
      PickerIconsEnum.Holiday,
      PickerIconsEnum.Path,
      PickerIconsEnum.Schedule,
      PickerIconsEnum.MoneyBillsCoins,
      PickerIconsEnum.MoneyBillsStack,
      PickerIconsEnum.CreditCard,
      PickerIconsEnum.GraphLine,
      PickerIconsEnum.GraphArea,
      PickerIconsEnum.GraphBar,
      PickerIconsEnum.Code,
      PickerIconsEnum.Target,
    ],
  },
  {
    name: 'Help & Info',
    icons: [
      PickerIconsEnum.Chat,
      PickerIconsEnum.ChatQuestion,
      PickerIconsEnum.QuestionCircle,
      PickerIconsEnum.Info,
      PickerIconsEnum.Book,
      PickerIconsEnum.BookOpenPencil,
    ],
  },
  {
    name: 'Miscellaneous',
    icons: [
      PickerIconsEnum.Link,
      PickerIconsEnum.Image,
      PickerIconsEnum.ParagraphGrid,
      PickerIconsEnum.BulletList,
      PickerIconsEnum.PartyPopper,
    ],
  },
  {
    name: 'People',
    icons: [
      PickerIconsEnum.PersonCircle,
      PickerIconsEnum.SmileyFace,
      PickerIconsEnum.People,
      PickerIconsEnum.ContactCard,
      PickerIconsEnum.Resume,
    ],
  },
  {
    name: 'Food & Drink',
    icons: [PickerIconsEnum.BeverageWineGlasses, PickerIconsEnum.BeverageCoffee, PickerIconsEnum.Cutlery],
  },
];
